import { createAction } from 'redux-actions';

import * as ACTION from './constants';

export const successExportDeliveryNote = createAction(ACTION.DELIVERY_NOTE_EXPORT.SUCCESS);
